import * as React from 'react';
const SvgDottedLine = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 264, height: 1, fill: "none" }, props),
    React.createElement("path", { stroke: "#483B43", strokeDasharray: "2 2", d: "M0 .5h264" })));
export default SvgDottedLine;
